module.exports = __webpack_public_path__ + "img/way.2eafcbad.png";